/**
 * Where the API lives, in one place.
 *
 * Seventeen files each built this string themselves from
 * `process.env.REACT_APP_BACKEND_URL`, which baked the build machine's address
 * into the bundle. That is wrong everywhere the app actually ships: the
 * desktop build starts its backend on a port chosen at runtime, and on a phone
 * "localhost" is the phone rather than the Mac.
 *
 * So the production build leaves the variable empty and every call goes to
 * `/api` on whatever origin served the page. The backend serves the built
 * frontend itself, so that origin is always the right one. The dev server on
 * port 3000 keeps the absolute URL through `.env`, which is why this still
 * honours an absolute value when one is given.
 */

const RAW = process.env.REACT_APP_BACKEND_URL || "";

/** The origin the backend is on, or "" when it is the origin serving this page. */
export const API_ORIGIN = RAW.replace(/\/+$/, "");

/** Prefix for every API call. Relative unless an absolute origin was configured. */
export const API = `${API_ORIGIN}/api`;

export default API;
